

import React from "react";
import { InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";

const ProfileSearch = ({ searchQuery, setSearchQuery, showTitle = true }) => {
  /**
   * Handle input change and update the search query.
   */
  const handleChange = (event) => {
    setSearchQuery(event.target.value);
  };

  return (
    <MDBox>
      {/* 🟣 Title */}
      {showTitle && (
        <MDTypography
          variant="button"
          fontWeight="medium"
          color="text"
          sx={{
            marginBottom: 1,
            display: "block",
            textAlign: "center",
          }}
        >
          Search Profiles
        </MDTypography>
      )}

      {/* 🩶 Grey background container */}
      <MDBox
        sx={{
          borderRadius: "16px",
          backgroundColor: "#f0f2f5",
          padding: "14px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <MDInput
          type="text"
          placeholder="Filter profiles by name..."
          fullWidth
          value={searchQuery}
          onChange={handleChange}
          sx={{
            // minWidth: "340px",
            // maxWidth: "420px",
            flexGrow: 1,
            "& .MuiInputBase-root": {
              borderRadius: "12px",
              backgroundColor: "white !important",
              boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
              paddingLeft: "6px",
            },
          }}

        />
      </MDBox>
    </MDBox>
  );
};

export default ProfileSearch;

